/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Privacylist_Nopersonaldata3Inputs */

const id_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data pribadi yang diperlukan selain kunci API Anda`)
};

const ms_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data peribadi diperlukan selain kunci API anda`)
};

const da_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen personlige data er påkrævet ud over din API-nøgle`)
};

const de_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es werden außer Ihrem API-Schlüssel keine personenbezogenen Daten benötigt`)
};

const en_us2_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No personal data is required beyond your API key`)
};

const es_es2_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se requieren datos personales más allá de tu clave de API`)
};

const es_mx2_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se requieren datos personales más allá de tu clave de API`)
};

const fil_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang personal na data ang kinakailangan bukod sa iyong API key`)
};

const fr_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée personnelle n'est requise au-delà de votre clé API`)
};

const it_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato personale è richiesto oltre alla tua chiave API`)
};

const hu_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az API kulcsodon kívül nincs szükség személyes adatokra`)
};

const nl_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er zijn geen persoonlijke gegevens nodig naast je API-sleutel`)
};

const no_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen personopplysninger kreves utover API-nøkkelen din`)
};

const pl_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie są wymagane żadne dane osobowe poza kluczem API`)
};

const pt_br2_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado pessoal é necessário além da sua chave API`)
};

const pt_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dado pessoal é necessário além da sua chave de API`)
};

const ro_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu sunt necesare date personale dincolo de cheia API`)
};

const fi_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henkilötietoja ei tarvita API-avaimen lisäksi`)
};

const sv_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga personuppgifter krävs utöver din API-nyckel`)
};

const vi_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không yêu cầu dữ liệu cá nhân ngoài khóa API của bạn`)
};

const tr_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarınız dışında kişisel veri gerekmez`)
};

const cs_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kromě vašeho API klíče nejsou vyžadována žádná osobní data`)
};

const bg_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не се изискват лични данни освен вашия API ключ`)
};

const ru_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Личные данные не требуются, кроме вашего API-ключа`)
};

const uk_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не потрібні персональні дані, окрім вашого API-ключа`)
};

const ar_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا حاجة لبيانات شخصية تتجاوز مفتاح API الخاص بك`)
};

const hi_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी API कुंजी के अलावा कोई व्यक्तिगत डेटा आवश्यक नहीं है`)
};

const th_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่จำเป็นต้องมีข้อมูลส่วนบุคคลนอกจากคีย์ API ของคุณ`)
};

const ja_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キー以外の個人データは不要です`)
};

const zh_cn2_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除API密钥外，无需任何个人数据`)
};

const zh_hant1_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除API金鑰外，無需任何個人資料`)
};

const ko_notifications_privacylist_nopersonaldata3 = /** @type {(inputs: Notifications_Privacylist_Nopersonaldata3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 키 외에는 개인 데이터가 필요하지 않습니다`)
};

/**
* | output |
* | --- |
* | "No personal data is required beyond your API key" |
*
* @param {Notifications_Privacylist_Nopersonaldata3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_privacylist_nopersonaldata3 = /** @type {((inputs?: Notifications_Privacylist_Nopersonaldata3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Privacylist_Nopersonaldata3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "ms") return ms_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "da") return da_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "de") return de_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "en-US") return en_us2_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "es-ES") return es_es2_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "es-MX") return es_mx2_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "fil") return fil_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "fr") return fr_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "it") return it_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "hu") return hu_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "nl") return nl_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "no") return no_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "pl") return pl_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "pt") return pt_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "ro") return ro_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "fi") return fi_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "sv") return sv_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "vi") return vi_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "tr") return tr_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "cs") return cs_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "bg") return bg_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "ru") return ru_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "uk") return uk_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "ar") return ar_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "hi") return hi_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "th") return th_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "ja") return ja_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_privacylist_nopersonaldata3(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_privacylist_nopersonaldata3(inputs)
	return ko_notifications_privacylist_nopersonaldata3(inputs)
});
export { notifications_privacylist_nopersonaldata3 as "notifications.privacyList.noPersonalData" }